export default __webpack_public_path__ + "static/media/host-link-icon.4b0afff2.svg";